<template>
  <AppLayout>
    <div class="content">
      <img alt="Hellocare" src="../../assets/images/signup-success.png">
      <p class="text">
        Si ce compte existe, un email contenant un lien vous permettant de modifier votre mot de passe vous a été envoyé
      </p>
    </div>
  </AppLayout>
</template>

<script>
  import AppLayout from '@/components/AppLayout.vue';
  import ButtonGreen from '@/components/ButtonGreen.vue';

  export default {
    name: 'ForgottenPasswordStep2Page',
    components: { ButtonGreen, AppLayout },
  };
</script>

<style lang="scss" scoped>
  img {
    display: block;
    width: 100px;
    margin: 0 auto 3rem;
  }

  .text {
    font-weight: 500;
    text-align: center;
    font-size: 3rem;
  }
</style>
